import date from './Date';
import regex from './Regex';
import round from './Round';
import escape from './Escape';
import unique from './Unique';
import extract from './Extract';
import replace from './Replace';
import jsonSafe from './JsonSafe';
import urlEncode from './UrlEncode';
import dateModify from './DateModify';
import jsonDecode from './JsonDecode';
import jsonEncode from './JsonEncode';
import length from './ExplodeToJsonArray';
import numberFormat from './NumberFormat';
import queryParameter from './QueryParameter';
import explodeToJsonArray from './ExplodeToJsonArray';

const defaultFilters = [
  date,
  dateModify,
  escape,
  replace,
  explodeToJsonArray,
  extract,
  jsonSafe,
  numberFormat,
  round,
  queryParameter,
  regex,
  unique,
  urlEncode,
  length,
  jsonEncode,
  jsonDecode
];

const filters = {
  date,
  dateModify,
  escape,
  replace,
  explodeToJsonArray,
  extract,
  jsonSafe,
  numberFormat,
  round,
  queryParameter,
  regex,
  default: defaultFilters,
  unique,
  urlEncode,
  length,
  jsonEncode,
  jsonDecode
};

export default filters;
